module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-title.5580868d.svg";